export default function eq(left: unknown, right: unknown): boolean {
  return left === right;
}
